var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSimpleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6375 0.29605C13.0996 0.709511 13.123 1.40221 12.6898 1.84323L5.99859 8.65404C5.57341 9.08682 4.86434 9.11763 4.39971 8.72351L0.385006 5.31811C-0.0884794 4.91648 -0.131128 4.22462 0.289748 3.77279C0.710624 3.32096 1.43565 3.28026 1.90913 3.68189L5.08894 6.37911L11.0161 0.34596C11.4494 -0.0950655 12.1753 -0.117411 12.6375 0.29605Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleCheck);
export default __webpack_public_path__ + "static/media/simpleCheck.95413150.svg";
export { ForwardRef as ReactComponent };